/**
 *@author chenli
 *@description 时间控件
 */
import Component from '../../../lib/component'
import template from './time-control.html'
import './time-control.scss';
import WXtemplate from './time-control.wx.html'
import BaseControl from '../WXbase-control/WXbase-control';
import msgbox from "../../../lib/msgbox";

let config = {
    template: template,
    data: {
        // width: '240px'
    },
    actions: {
        //时间日期输入错误提示
        keyup: function () {
            let _this = this;
            //hh:mm:ss
            let strDate = this.el.find(".timeInput").val();
            let re = /^((20|21|22|23|[0-1]\d)\:[0-5][0-9])(\:[0-5][0-9])?$/;
			if(strDate){
                if (re.test(strDate))//判断日期格式符合hh:mm:ss标准
                {
                    this.el.find(".hour").children("span").text(strDate.substring(0, 2))
                    this.el.find(".minute").children("span").text(strDate.substring(3, 5));
                    this.el.find(".second").children("span").text(strDate.substring(6, 8));
                    this.el.find("#errorMessage").css("display", "none");
                    if (_this.data.isAgGrid&&!_this.data.isAgGrid) {
                        _this.data.value = strDate.replace(/\//g, "-");
                        _this.actions.changeValue();
                    }
                }
			}
			else {
				if (document.querySelector(".time").style.display == "none"){
                    if (!_this.data.isAgGrid) {
                            _this.data.value = strDate.replace(/\//g, "-");
                            _this.actions.changeValue();
                        }
				}

			}


        },
	    init(){
		    let _this = this;

		    //增加0
		    function p(s) {
			    return s < 10 ? '0' + s : s;
		    }

		    //获取当前时间
		    let myDate = new Date();
		    let h = myDate.getHours();
		    let m = myDate.getMinutes();
		    let s = myDate.getSeconds();
		    let now = p(h) + ':' + p(m) + ":" + p(s);

		    let timeInput = _this.el.find(".timeInput");
		    let hour = this.el.find(".hour").children("span");
		    let minute = this.el.find(".minute").children("span");
		    let second = this.el.find(".second").children("span");
		    let time =  this.el.find(".time")

		    //回显
		    if (_this.data.value) {
			    timeInput.val(_this.data.value);
			    hour.text(_this.data.value.substring(0, 2))
			    minute.text(_this.data.value.substring(3, 5));
			    second.text(_this.data.value.substring(6, 8));

		    } else {
			    timeInput.val('时:分:秒');
			    hour.text(p(h));
			    minute.text(p(m));
			    second.text(p(s));
		    }

		    this.el.on("click", '.timeInput', function () {
			    if(_this.data.isAgGrid){
				    time.css({'position': 'fixed','display':'block'});
			    }else{
				    time.css({'display': 'block','position':'absolute'});
			    }
			    if (_this.data.value) {
				    timeInput.val(_this.data.value);
			    } else {
				    timeInput.val(now);
				    if(_this.data.isAgGrid&&!_this.data.isAgGrid){
					    _this.data.value = now;
					    _this.actions.changeValue();
				    }
			    }
		    })
		    this.el.on("click", '.plus', function () {
			    //当前时间+1
			    let myDate2 = new Date();
			    let h = parseInt(_this.el.find('.hour span').text());
                let m = parseInt(_this.el.find('.minute span').text());
                let s = parseInt(_this.el.find('.second span').text());
			    myDate2.setHours(h + 1);
			    myDate2.setMinutes(m + 1);
			    myDate2.setSeconds(s + 1);
			    if ($(this).parents().hasClass("hour")) {
				    h = myDate2.getHours();
				    hour.text(p(h));
			    } else if ($(this).parents().hasClass("minute")) {
				    m = myDate2.getMinutes();
				    minute.text(p(m));
			    } else {
				    s = myDate2.getSeconds();
				    second.text(p(s));
			    }
			    let now2 = p(h) + ':' + p(m) + ":" + p(s);
			    now = now2
			    timeInput.val(now);
			    if (_this.data.isAgGrid&&!_this.data.isAgGrid) {
				    _this.data.value = now;
				   _this.actions.changeValue();
			    }

		    });
		    this.el.on("click", '.reduce', function () {
			    //当前时间-1
			    let myDate3 = new Date();
                let h = parseInt(_this.el.find('.hour span').text());
                let m = parseInt(_this.el.find('.minute span').text());
                let s = parseInt(_this.el.find('.second span').text());
			    myDate3.setHours(h - 1);
			    myDate3.setMinutes(m - 1);
			    myDate3.setSeconds(s - 1);
			    if ($(this).parents().hasClass("hour")) {
				    h = myDate3.getHours();
				    hour.text(p(h));
			    } else if ($(this).parents().hasClass("minute")) {
				    m = myDate3.getMinutes();
				    minute.text(p(m));
			    } else {
				    s = myDate3.getSeconds();
				    second.text(p(s));
			    }
			    let now3 = p(h) + ':' + p(m) + ":" + p(s);
			    now = now3;
			    timeInput.val(now);
			    if (_this.data.isAgGrid&&!_this.data.isAgGrid) {
				    _this.data.value = now;
				    _this.actions.changeValue();
			    }

		    });

		    this.el.find('.timeInput').on('input', _.debounce(function () {
			    _this.actions.keyup();
		    }, 200));
		    if(_this.data.isAgGrid&&!_this.data.isAgGrid){
                _this.actions.changeValue();
		    }

	    },
	    changeValue(){
	    	let _this=this;
		    _.debounce(function () {
			    _this.events.changeValue(_this.data)
		    }, 200)();
	    },
	    iconCheck(){
		    this.el.find('.ui-width').css('width', this.data.width);
		    this.el.find('.time').css('width', this.data.width);
		    //修改历史
		    if(! this.data.isCalendar && !this.data.isAgGrid && this.data.history){
			    this.el.find('.ui-history').css('visibility','visible');
		    }
		    if(this.data.isCalendar || this.data.isAgGrid) {
			    this.el.find('.ui-history').css('visibility','hidden');
		    }

		    this.el.find('.ui-width').attr('title', this.data.value)
		    //查看模式/编辑模式
		    if (this.data.is_view) {
			    this.el.find('.ui-width').attr('disabled', true);
			    this.el.find('.input-img').css('pointer-events', 'none');
		    } else {
			    this.el.find('.ui-width').attr('disabled', false);
		    }
	    }
    },
    binds: [
        {
            event: 'click',
            selector: '.ui-history',
            callback: function () {
                this.events.emitHistory(this.data);
            }
        },
        {
            event: 'click',
            selector: '.ui-datepicker-current',
            callback: function () {
                //增加0
                function p(s) {
                    return s < 10 ? '0' + s : s;
                }

                //获取当前时间
                let myDate = new Date();
                let h = myDate.getHours();
                let m = myDate.getMinutes();
                let s = myDate.getSeconds();
                let now = p(h) + ':' + p(m) + ":" + p(s);

                let nowTime = this.el.find(".timeInput").val(now);
                this.data.value = now;
                // _.debounce(() => {
                //     this.events.changeValue(this.data)
                // }, 200)();
                this.el.find(".hour").children("span").text(p(h));
                this.el.find(".minute").children("span").text(p(m));
                this.el.find(".second").children("span").text(p(s));
            }
        },
        {
            event: 'click',
            selector: '.input-img',
            callback: function () {
            	let _this = this;
                let strDate = this.el.find(".timeInput").val();
                let re = /^((20|21|22|23|[0-1]\d)\:[0-5][0-9])(\:[0-5][0-9])?$/;
                if (strDate!='时:分:秒') {
                    if(strDate){
                        if (re.test(strDate)) {
                            if (document.querySelector('.time').style.display!=='none') {
                                _this.data.value = strDate;
                                _.debounce(function () {
                                    _this.events.changeValue(_this.data)
                                }, 200)();
                            }

                        }
                        else {
                            _this.data.value = "";
                            _this.el.find(".timeInput").val('');
                            msgbox.alert("请按照hh:mm:ss格式输入")
                        }
                    }
                    else {
                        if (document.querySelector('.time').style.display!=='none') {
                            _this.data.value = strDate;
                            _.debounce(function () {
                                _this.events.changeValue(_this.data)
                            }, 200)();
                        }

                    }
				}
				else {
					if (document.querySelector('.time').style.display!=='none') {
                        _this.data.value = "";
                        _this.el.find(".timeInput").val('');
                        msgbox.alert("请按照hh:mm:ss格式输入")
					}
				}


                if(this.data.isAgGrid){
                    this.el.find('.time').css({'position': 'fixed'}).toggle();
                }else{
                    this.el.find('.time').css({'position': 'absolute'}).toggle();
                }
            }
        },

        {
            event: 'click',
            selector: '.ui-datepicker-close',
            callback: function () {
                let _this = this;
                this.el.find('.time').css('display', 'none');
                let re = /^((20|21|22|23|[0-1]\d)\:[0-5][0-9])(\:[0-5][0-9])?$/;
                let strDate = this.el.find(".timeInput").val();
				if(strDate){
                    if (re.test(strDate)) {
                        _this.data.value = strDate;
                        _.debounce(function () {
                            _this.events.changeValue(_this.data)
                        }, 200)();
                    }else {
                        _this.data.value = "";
                        _this.el.find(".timeInput").val('');
                        msgbox.alert("请按照hh:mm:ss格式输入")
                    }
				}
				else {
                    _this.data.value = strDate;
                    _.debounce(function () {
                        _this.events.changeValue(_this.data)
                    }, 200)();
				}
            }
        }


    ],
    afterRender() {
    	this.actions.iconCheck();
      this.actions.init();
    },
    beforeDestory: function () {
        $(document).off('click:timeControl');
        this.el.off();
    }

}
let TimeControl = Component.extend(config)
export default TimeControl;

let WXconfig={
	data:{controlHtml:WXtemplate},
	actions:{
		init(){
			let _this=this;
			this.el.find('.timeInput').on('input',_.debounce(function () {
				_this.data.value=$(this).val();
			},200))
			//回显
			if (this.data.value) {
				this.el.find('.timeInput').val(this.data.value);
			}
		}
	},
	afterRender(){
		this._super.afterRender();
		this.actions.init();
	}
}
let TimeControlWX=BaseControl.extend(WXconfig);
export {TimeControlWX}


// WEBPACK FOOTER //
// app/components/form/time-control/time-control.js